export default function clickSaveDraft(fn: () => void) {
  const button = document.getElementsByClassName(
    'ob-button-save-draft',
  )[0] as HTMLButtonElement
  if (button) {
    button.click()
    fn()
  }
}
